import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=cdd7f214"
import script from "./RegisterCard.vue?vue&type=script&lang=js"
export * from "./RegisterCard.vue?vue&type=script&lang=js"
import style0 from "./RegisterCard.vue?vue&type=style&index=0&id=cdd7f214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports